module.exports = __webpack_public_path__ + "img/thumb_12.b09e77ad.jpg";